const hackathonData = [
  {
    name: "HackDearborn 2",
    projectName: "Personalised Medicine",
    year: "2023",
    description: "",
    github: "https://github.com/ankitan07/Hack_dearborn_2",
    devpost: "https://devpost.com/software/personalized-medicines"
  },
  {
    name: "HackDearborn 3",
    projectName: "TutorVerse",
    year: "2024",
    description: "Participated in building TutorVerse, an educational platform connecting students and tutors for real-time Q&A.",
    github: "https://github.com/alpaslan-exe/TutorVerse",
    devpost: "https://devpost.com/software/teach_llm"
  },
  {
    name: "Wayne Hacks 3",
    projectName: "Scales and Tails",
    year: "2025",
    description: "Developed Duck Identifier - an app using ML for image recognition of duck breeds, showcased at Wayne Hacks.",
    github: "https://github.com/lsabrina51/Scales-and-Tails",
    devpost: "https://devpost.com/software/duck-identifier"
  }
];

export default hackathonData;
